// extracted by mini-css-extract-plugin
export var container = "_5b-0";
export var infoButton = "_5b-1";
export var label = "_5b-3";
export var labelExpanded = "_5b-4";
export var price = "_5b-5";
export var priceExpanded = "_5b-6";
export var title = "_5b-2";